import bootbox from 'bootbox';
import formulas from './formula_functions';
import tinymce from "tinymce";
import formula_functions from "./formula_functions";

$(document).ready(function () {

    let $body = $('body');

    let _button_id = $(`input[name="_button_id"]`).val();

    let searchRequest = null;

    if (_button_id && _button_id.length) {
        populateRelationMappings();
    }

    $('#create-modal').on('hidden.bs.modal', function () {
        let $field = $('.create-modal-field');
        $field.removeClass('create-modal-field');
        $('#create-body').empty();
    });

    $('#relation-modal').on('hidden.bs.modal', function () {
        $('#relation-body').html('').removeAttr('data-record-count').removeAttr('data-loaded-record-count');
        $('#relation-modal').attr('data-table-id', '');
        $('#save-relation').addClass('d-none');
        $('#relation-search').val('');
        $('.table-relation').removeClass('focused');
        $('.editable-td').removeClass('editing');
    });

    $('#relation-modal').on('shown.bs.modal', function () {
        $('#relation-search').focus();
        $('#relation-body').off('scroll').on('scroll', initRelationInfiniteScroll);
    });

    $body.on('click', '.open-link', function (e) {
        let url = $(this).parents('.form-group').find('.data-input').val();
        var regex = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
        if (regex.test(url)) {
            window.open(url, '_blank').focus();
        } else {
            url = 'http://' + url;
            window.open(url, '_blank').focus();
        }
    });

    $body.on('click', '.table-relation', function (e) {
        $(document).find('.table-relation').removeClass('focused');
        $(this).addClass('focused');
        $('#save-relation').attr('data-action', 'creating');

        let $modal = $('#relation-modal'),
            buttons = false,
            container = '.form-group';

        if ($(this).hasClass('button-relation')) {
            $modal.attr('data-source', 'buttons');
            buttons = true;
            container = '.input-group';
        } else {
            $modal.attr('data-source', 'create-update');
        }

        let $field = $(this).parents(container).find('.data-input'),
            field_id = $field.data('id'),
            table_id = $field.attr('data-relation-id'),
            related_fields = JSON.parse($field.attr('data-related-fields')),
            primary_column = $field.attr('data-primary-column'),
            filter_column = $field.attr('data-filter-column'),
            related_filter = $field.attr('data-related-filter'),
            primary_keys = $field.attr('data-primary-keys'),
            count = $field.attr('data-related-records-count'),
            disable_create = $(this).data('disable-create'),
            selected_id = '',
            payload = [];

        $('#new-record-modal').attr('disabled', !!disable_create);

        if ($field.val().length) {
            selected_id = $(this).parents(container).find('.hidden-relation').val();
        }

        if (primary_column) {
            if (primary_keys && !buttons) {
                primary_keys = JSON.parse(primary_keys);
                for (let i = 0; i < primary_keys.length; i++) {

                    let $target = $('#' + primary_keys[i][0]),
                        type = $target.attr('type'),
                        val = '';

                    if ($target.hasClass('relation-data-field')) {
                        val = $target.siblings('input[type="hidden"]').val();
                    } else {
                        val = $target.val();
                    }

                    payload.push([primary_keys[i][1], val]);
                }
            }

            $.ajax({
                type: 'GET',
                url: '/relation/data',
                data: {
                    id: table_id,
                    columns: related_fields,
                    primary_column: primary_column,
                    filter_column: filter_column,
                    payload: payload,
                    skip: 0,
                    load_more: 0,
                    selected_id: selected_id,
                    field_id: field_id
                },
                success: function (table) {

                    $('#relation-title').text(table.name);

                    $('#relation-modal')
                        .attr('data-field-id', field_id)
                        .attr('data-table-id', table_id)
                        .attr('data-mode', 'create')
                        .attr('data-is-button', $('.create-button-form').length)
                        .modal('show');

                    $('#related-filter-container').html(table.filter_dom);

                    $('#relation-body').html(table.modal_dom)
                        .attr('data-record-count', count)
                        .attr('data-loaded-record-count', 50)
                        .attr('data-loading', 0)
                        .attr('data-is-loaded', 0);

                    if ($field.val().length) {
                        $(".relation-row[data-id='" + selected_id + "']").addClass('selected');
                        // $('#save-relation').removeClass('d-none');
                        $('#remove-relation').removeClass('d-none');
                    }

                    if (!table.create_permission) {
                        $('#new-record-modal').attr('disabled', true);
                    }

                    setTimeout(function (e) {
                        attachResizeForRelationTable();
                    }, 200);
                }
            });
        } else {
            bootbox.alert("Please define primary column for this field in customizer…");
        }
    });

    $body.tooltip({
        items: ".multitooltip, .html-tooltip, .multiline-tooltip, .tooltip, .tootip",
        content: function (callback) {
            if ($(this).hasClass('multitooltip')) {
                let table_id = $(this).attr('data-table-id'),
                    record_id = $(this).attr('data-record-id');

                callback('<img width="50" src="https://icon-library.com/images/spinner-icon-gif/spinner-icon-gif-10.jpg"/>');

                $.ajax({
                    type: 'GET',
                    url: '/browse-multi-users/' + table_id,
                    data: {
                        record: record_id
                    },
                    success: (res) => {
                        callback(res);
                    }
                });
            } else if ($(this).hasClass('html-tooltip')) {
                let html = $(this).attr('data-value');
                callback(html);
            } else if ($(this).hasClass('multiline-tooltip')) {
                let html = $(this).attr('data-multiline');
                callback(html);
            } else if ($(this).hasClass('tooltip') || $(this).hasClass('tootip')) {
                let table_id = $(this).attr('data-table-id'),
                    id = $(this).attr('data-id'),
                    related_field = $(this).attr('data-related-field');

                callback('<img width="50" src="https://icon-library.com/images/spinner-icon-gif/spinner-icon-gif-10.jpg"/>');

                $.ajax({
                    type: 'GET',
                    url: '/relation/data/info',
                    data: {
                        id,
                        table_id,
                        related_field
                    },
                    success: (res) => {
                        callback(res);
                    }
                });
            }
        }
    });

    $body.on('scroll', '#relation-body', initRelationInfiniteScroll);

    $body.on('keyup', '.relation-data-field', relationSearchDelay(function (e, action = null) {
        $body.find('.relation-data-field').removeClass('active-relation');
        $(this).addClass('active-relation');
        let $detached = $('.autocomplete-items.detached');

        if (searchRequest) {
            searchRequest.abort();
        }

        if (!action || action === 'barcode') {
            let search = $(this).val(),
                search_lower = search.toLowerCase(),
                field = $(this).attr('data-id'),
                $field = $(this),
                field_id = parseInt($field.attr('data-field')),
                primary_keys = $field.attr('data-primary-keys'),
                $ac_holder = $(this).siblings('.autocomplete-items'),
                $hidden_field = $(this).siblings('.hidden-relation'),
                type = $(this).attr('data-type'),
                is_insert = $(this).hasClass('insert-field'),
                width = $field.width(),
                extra_width = 20,
                modal = $(this).parents('.create-dialog-form').length,
                $edit_icon = $field.siblings('.edit-relation'),
                disable_create = $(this).data('disable-create'),
                payload = [],
                $this = $(this),
                button = false;

            let barcode_fields = [2237, 2238, 2239, 2278, 2279, 2280, 2273, 2274, 2275];
            if (window.tenant === 'potocnik' && barcode_fields.includes(field_id) && $field.parents('.button-container').length) {
                let serial = search.replace(/[^a-zA-Z0-9]/g, '');
                serial = extractSerialNumber(serial);
                if (serial) {
                    search = serial;
                    $(this).val(search);
                }
            }

            if (primary_keys && !$field.parents('.button-container').length) {
                primary_keys = JSON.parse(primary_keys);
                for (let i = 0; i < primary_keys.length; i++) {

                    let $target = $('#' + primary_keys[i][0]),
                        type = $target.attr('type'),
                        val = '';

                    if ($target.hasClass('relation-data-field')) {
                        val = $target.siblings('input[type="hidden"]').val();
                    } else {
                        val = $target.val();
                    }

                    payload.push([primary_keys[i][1], val]);
                }
            }

            $edit_icon.removeClass('show-edit');

            if (width < 200 && is_insert) {
                extra_width += 150;
            }

            if (type === 'quick-add') {
                field = $(this).parents('.editable-td').attr('data-field');
            }

            if (!$ac_holder.length) {
                $ac_holder = $('.autocomplete-items.detached');
                $ac_holder.empty();
            } else {
                $ac_holder.css({
                    position: 'absolute',
                    top: $field.offset().top + 40,
                    left: $field.offset().left,
                    width: $field.width() + extra_width,
                    'z-index': 1050
                }).addClass('detached').detach().appendTo('body');
            }

            $hidden_field.val('');

            if (search.length) {
                searchRequest = $.ajax({
                    type: 'GET',
                    url: '/relation/data/search',
                    data: {
                        search,
                        field,
                        type,
                        modal,
                        disable_create,
                        payload
                    },
                    success: function (res) {
                        if (res) {
                            $ac_holder.html(res).removeClass('d-none');
                            let $selected = $ac_holder.find('.relation-data-record[data-lower-text="' + search_lower + '"]');
                            if ($selected.length) {
                                if ($hidden_field.length) {
                                    $hidden_field.val($selected.attr('data-col'));
                                    if (e.originalEvent === undefined) {
                                        $ac_holder.empty().addClass('d-none');
                                    }
                                } else if ($this.parents('.editable-td').length) {
                                    if (e.originalEvent === undefined) {
                                        $this.parents('.editable-td').attr('data-value', $selected.attr('data-col'));
                                        $this.parents('.editable-td').addClass('update');
                                        $ac_holder.empty().addClass('d-none');
                                    }
                                }
                            }
                            if (action === 'barcode') {
                                $ac_holder.find('.relation-data-record').first().trigger('click');
                            }
                        } else {
                            $ac_holder.empty().addClass('d-none');
                        }
                    }
                })
            } else {
                $ac_holder.empty().addClass('d-none');
            }
        }
    }, 300));

    $body.on('click', '.table-relation-autocomplete', function (e) {
        let search = $(this).val(),
            field = $(this).attr('data-id'),
            $field = $(this).siblings('.relation-data-field'),
            primary_keys = $field.attr('data-primary-keys'),
            $ac_holder = $(this).siblings('.autocomplete-items'),
            $hidden_field = $(this).siblings('.hidden-relation'),
            type = $(this).attr('data-type'),
            is_insert = $(this).hasClass('insert-field'),
            width = $field.width(),
            extra_width = 20,
            modal = $(this).parents('.create-dialog-form').length,
            disable_create = $(this).data('disable-create'),
            payload = [],
            button = false;

        $body.find('.relation-data-field').removeClass('active-relation');
        $field.addClass('active-relation');
        $field.focus();

        if (primary_keys && !$field.parents('.button-container').length) {
            primary_keys = JSON.parse(primary_keys);
            for (let i = 0; i < primary_keys.length; i++) {

                let $target = $('#' + primary_keys[i][0]),
                    type = $target.attr('type'),
                    val = '';

                if ($target.hasClass('relation-data-field')) {
                    val = $target.siblings('input[type="hidden"]').val();
                } else {
                    val = $target.val();
                }

                payload.push([primary_keys[i][1], val]);
            }
        }

        if (type === 'quick-add') {
            field = $(this).parents('.editable-td').attr('data-field');
        }

        if (!$ac_holder.length) {
            $ac_holder = $('.autocomplete-items.detached');
            $ac_holder.empty();
        } else {
            $ac_holder.css({
                position: 'absolute',
                top: $field.offset().top + 40,
                left: $field.offset().left,
                width: $field.width() + extra_width,
                'z-index': 1200
            }).addClass('detached').detach().appendTo('body');
        }

        $hidden_field.val('');

        $.ajax({
            type: 'GET',
            url: '/relation/data/search',
            data: {
                search,
                field,
                type,
                modal,
                disable_create,
                payload
            },
            success: function (res) {
                if (res) {
                    $ac_holder.html(res).removeClass('d-none');
                    let $selected = $ac_holder.find('.relation-data-record[data-text="' + search + '"]');
                    if ($selected.length) {
                        $hidden_field.val($selected.attr('data-col'));
                    }
                } else {
                    $ac_holder.empty().addClass('d-none');
                }
            }
        })
    });

    $body.on('focusout', '.relation-data-field', function (e) {
        let $hidden_field = $(this).siblings('.hidden-relation'),
            $ac_holder = $body.find('.autocomplete-items.detached'),
            $field = $body.find('.relation-data-field.active-relation');

        setTimeout(function () {
            $field.after($ac_holder.detach());
            $ac_holder.removeClass('detached');
            $ac_holder.empty().addClass('d-none');
            $field.removeClass('active-relation');
        }, 400);
        // if (!$hidden_field.val().length) {
        // } else {
        // }
    });

    $body.on('click', '.relation-data-record', function (e) {
        let id = $(this).attr('data-col'),
            text = $(this).attr('data-text'),
            can_edit = parseInt($(this).attr('data-can-edit')),
            is_button_form = $('.create-button-form').length,
            is_web_form = $('.webform-builder-form').length;

        let $field = $body.find('.relation-data-field.active-relation'),
            $hidden_field = $field.parents('.form-group').find('.hidden-relation'),
            $ac_container = $body.find('.autocomplete-items.detached'),
            $edit_icon = $field.siblings('.edit-relation'),
            type = $field.attr('data-type');

        if (can_edit) {
            $edit_icon.addClass('show-edit');
        } else {
            $edit_icon.removeClass('show-edit');
        }

        if (is_button_form || is_web_form) {
            $hidden_field = $field.siblings('.hidden-relation');
        }

        if (type === 'quick-add') {
            let $editable = $field.parents('.editable-td');
            $editable.attr('data-value', id).addClass('update');
            $field.val(text).closest('.form-group').addClass('control-highlight');
            retrieveQuickAddMappingValues($editable, $editable.attr('data-mappings'), $editable.attr('data-relation-id'), id, $editable.attr('data-primary-column'));
        } else {
            let field_name = $field.attr('name'),
                table_name = $field.attr('data-table-name'),
                table_id = parseInt($field.attr('data-table-id')),
                page = $field.attr('data-page');

            $field.val(text).closest('.form-group').addClass('control-highlight');
            $hidden_field.val(id).trigger('keyup');
            $field.trigger('keyup');
            $field.trigger('focusout');

            retrieveMappingValues($field.attr('data-mappings'), $field.attr('data-relation-id'), id);

            if (field_name === 'vat_zone' &&
                (table_id === 8 ||
                    table_id === 10 ||
                    table_id === 23 ||
                    table_id === 59 ||
                    table_id === 15
                ) && page === 'edit') {
                updateRelatedProducts($field, field_name, table_id, id);
            }
        }
    });

    $body.on('click', '#new-record-modal', function (e) {

        let $modal = $('#relation-modal'),
            mode = $modal.attr('data-mode'),
            source = $modal.attr('data-source'),
            $field = '',
            field_id = $modal.attr('data-field-id'),
            row_id = $modal.attr('data-row-id'),
            $create_modal = $('#create-modal'),
            $create_body = $('#create-body'),
            $modal_title = $('#create-title'),
            $create_btn = $('#create-record'),
            $editable = '';

        $('#open-record').addClass('d-none');

        if (mode === 'create' || mode === 'quick_add') {
            if (mode === 'quick_add') {
                $editable = $('.quick-add-row').find(`.editable-td.editing[id="${field_id}"]`);
                $field = $editable.find('.relation-data-field');
            } else {
                $field = $(".table-relation[data-id='" + field_id + "']").parents('.form-group').find('.data-input');
            }
        } else if (mode === 'editing') {
            $field = $(`#${row_id}`);
        }

        let type = $field.attr('data-type'),
            relation_id = $field.attr('data-relation-id'),
            primary_key = $field.attr('data-primary-column');

        if (mode === 'quick_add') {
            relation_id = $editable.attr('data-relation-id');
            primary_key = $editable.attr('data-primary-column');
        }

        if (parseInt(relation_id) === 11) {
            $('#find-company-modal').removeClass('d-none');
        } else {
            $('#find-company-modal').addClass('d-none');
        }

        $modal.modal('hide');
        $field.addClass('create-modal-field');
        $create_btn.attr('data-table-id', relation_id);
        $create_btn.attr('data-primary-column', primary_key);
        $create_btn.attr('data-action', 'create');
        $create_btn.attr('data-mode', mode);

        $create_btn.text(translation.create);
        $modal_title.text(translation.create_record);

        $.ajax({
            type: 'GET',
            url: `/create/${relation_id}/dialog`,
            success: function (res) {
                $create_body.empty().html(res);
                $create_modal.modal('show');
                $('.form-group .form-control').each(function () {
                    $(this).floatingLabel('ChangeFortText');
                });
                window.initCreateEditFormFields($create_body);

                initTinyMCE();
            }
        });

    });

    $body.on('click', '.create-related-record', function (e) {
        let $field = $body.find('.relation-data-field.active-relation'),
            $hidden_field = $field.parents('.form-group').find('.hidden-relation'),
            $ac_container = $body.find('.autocomplete-items.detached'),
            $create_modal = $('#create-modal'),
            $create_body = $('#create-body'),
            $modal_title = $('#create-title'),
            $create_btn = $('#create-record'),
            type = $field.attr('data-type'),
            relation_id = '',
            primary_key = '',
            table_name = $(this).attr('data-table-name');

        $field.addClass('create-modal-field');

        if (table_name === 'Companies') {
            $('#find-company-modal').removeClass('d-none');
        } else {
            $('#find-company-modal').addClass('d-none');
        }

        if (type === 'quick-add') {
            let $editable = $field.parents('.editable-td');
            relation_id = $editable.attr('data-relation-id');
            primary_key = $editable.attr('data-primary-column');
        } else {
            relation_id = $field.attr('data-relation-id');
            primary_key = $field.attr('data-primary-column');
        }

        $create_btn.attr('data-table-id', relation_id);
        $create_btn.attr('data-primary-column', primary_key);
        $create_btn.attr('data-action', 'create');
        $create_btn.text(translation.create);
        $modal_title.text(translation.create_record);

        $.ajax({
            type: 'GET',
            url: `/create/${relation_id}/dialog`,
            success: function (res) {
                $create_body.empty().html(res);
                $create_modal.modal('show');
                $('.form-group .form-control').each(function () {
                    $(this).floatingLabel('ChangeFortText');
                });

                initTinyMCE();
            }
        })
    });

    $body.on('click', '#create-record:not([data-action="calendar"])', function (e) {
        let $form = $('.create-dialog-form')[0],
            id = $(this).attr('data-table-id'),
            primary_column = $(this).attr('data-primary-column'),
            $field = $('.create-modal-field'),
            $create_modal = $('#create-modal'),
            $create_body = $('#create-body'),
            // payload = $form.serializeArray(),
            $edit_icon = $field.siblings('.edit-relation'),
            url = '',
            action = $(this).attr('data-action'),
            mode = $(this).attr('data-mode'),
            record_id = $(this).attr('data-record-id');

        tinymce.triggerSave(true, true);

        $create_modal.find(`.text-danger`).empty().addClass('d-none');

        if (action === 'create') {
            url = `/savefield/${id}/dialog/${primary_column}`;
        } else {
            url = `/updatefield/${id}/dialog/${primary_column}`;
        }

        $.ajax({
            type: "POST",
            url: url,
            processData: false,
            contentType: false,
            cache: false,
            data: new FormData($form),
            success: function (res) {
                if (res) {
                    if ($field.parents('.button-container').length) {
                        let $editable = $field.parents('.editable-td');
                        $editable.attr('data-value', res.id).addClass('update');
                        $field.val(res.value)
                        retrieveQuickAddMappingValues($editable, $editable.attr('data-mappings'), id, res.id, primary_column);
                        $editable.find('.form-group').addClass('control-highlight');
                    } else {
                        if (mode === 'editing') {
                            if (!$field.attr('data-old-value')) {
                                $field.attr('data-old-value', $field.attr('data-value'));
                                $field.attr('data-old-text', $field.find('a').find('span').text().trim());
                            }
                            $field.find('a').find('span').text(res.value);
                            $field.attr('data-value', res.id);

                            $field.addClass('update');

                            $('.edit-buttons').removeClass('d-none');
                            retrieveEditMappingValues($field, $field.attr('data-mappings'), $field.attr('data-relation-id'), res.id, $field.attr('data-primary-column'));
                        } else {
                            $field.val(res.value)
                            $field.siblings('.hidden-relation').val(res.id);
                            retrieveMappingValues($field.attr('data-mappings'), id, res.id);
                        }
                    }
                    $field.closest('.form-group').addClass('control-highlight');
                    $edit_icon.addClass('show-edit');
                    $field.removeClass('create-modal-field');
                    $create_body.empty();
                    $create_modal.modal('hide');
                }
            },
            error: function (res) {
                let errors = res.responseJSON.errors;
                for (let key in errors) {
                    if (errors.hasOwnProperty(key)) {
                        $create_modal.find(`.text-danger[data-name="` + key + `"]`).text(errors[key]).removeClass('d-none');
                    }
                }
            }
        });
    });

    $body.on('click', '#cancel-record', function (e) {
        let $form = $('.create-dialog-form'),
            id = $(this).attr('data-table-id'),
            primary_column = $(this).attr('data-primary-column'),
            $field = $('.create-modal-field'),
            $create_modal = $('#create-modal'),
            $create_body = $('#create-body'),
            payload = $form.serializeArray(),
            $edit_icon = $field.siblings('.edit-relation');

        $create_body.empty();
        $field.removeClass('create-modal-field');
        $create_modal.modal('hide');
    });

    $body.on('click', '.edit-relation', function (e) {

        let type = $(this).attr('data-type'),
            $field = $(this).siblings('.relation-data-field'),
            $create_modal = $('#create-modal'),
            $modal_title = $('#create-title'),
            $create_body = $('#create-body'),
            $create_btn = $('#create-record'),
            relation_id = '',
            primary_key = '',
            record_id = '',
            table_name = $(this).attr('data-table-name');

        $field.addClass('create-modal-field');

        if (table_name === 'Companies') {
            $('#find-company-modal').removeClass('d-none');
        } else {
            $('#find-company-modal').addClass('d-none');
        }


        if (type === 'quick-add') {
            let $editable = $field.parents('.editable-td');
            relation_id = $editable.attr('data-relation-id');
            primary_key = $editable.attr('data-primary-column');
            record_id = $editable.attr('data-value');
        } else {
            relation_id = $field.attr('data-relation-id');
            primary_key = $field.attr('data-primary-column');
            record_id = $field.siblings('.hidden-relation').val();
        }

        $create_btn.attr('data-table-id', relation_id);
        $create_btn.attr('data-table-name', table_name);
        $create_btn.attr('data-primary-column', primary_key);
        $create_btn.attr('data-record-id', record_id);
        $create_btn.attr('data-action', 'update');
        $create_btn.text(translation.update);
        $modal_title.text(translation.edit_record);

        $.ajax({
            type: 'GET',
            url: `/edit-fields/${relation_id}/${record_id}/dialog`,
            success: function (res) {
                $create_body.empty().html(res.view);
                $('#open-record').attr('href', res.url).removeClass('d-none');
                $create_modal.modal('show');
                $('.form-group .form-control').each(function () {
                    $(this).floatingLabel('ChangeFortText');
                });

                window.initCreateEditFormFields($create_body);

                initTinyMCE();
            }
        })
    });

    let linkRequest = null;

    $(document).on({
        mouseenter: function () {
            let record_id = $(this).attr('data-value'),
                table = $(this).attr('data-related-table'),
                field = $(this).attr('data-field'),
                $link = $(this).find('a'),
                old_link = $link.attr('href'),
                hyperlink = $(this).attr('data-hyperlink'),
                $row = $(this).parents('tr');

            if (record_id.length) {
                if (hyperlink && hyperlink.length) {
                    $(this).attr('data-old-link', old_link);
                    $link.attr('href', hyperlink).attr('target', '_blank');
                    $(this).addClass('relation-hyperlink');
                    $row.addClass('linked');
                } else {
                    linkRequest = $.ajax({
                        type: 'GET',
                        url: '/relation/hyperlink',
                        data: {
                            record_id,
                            table,
                            field
                        },
                        success: (res) => {
                            if (res) {
                                $(this).attr('data-old-link', old_link);
                                $(this).attr('data-hyperlink', res);
                                $link.attr('href', res).attr('target', '_blank');
                                $(this).addClass('relation-hyperlink');
                                $row.addClass('linked');
                            }
                        }
                    })
                }
            }
        },
        mouseleave: function () {
            if (linkRequest) {
                linkRequest.abort();
            }

            let $link = $(this).find('a'),
                old_link = $(this).attr('data-old-link'),
                $row = $(this).parents('tr');

            if (old_link && old_link.length) {
                $(this).removeClass('relation-hyperlink');
                $link.attr('href', old_link).removeAttr('target');
            }

            $row.removeClass('linked');
        }
    }, ".relation-data.relationship");

    $body.on('click', '.relation-row', function (e) {
        if ($(this).hasClass('linked')) {
            return;
        }
        $('#relation-modal').find('.selected').removeClass('selected');
        $(this).addClass('selected');
        $('#save-relation').trigger('click');
    });

    $body.on('click', '#save-relation', function (e) {

        let action = $(this).attr('data-action'),
            $modal = $('#relation-modal'),
            $selected = $modal.find('.selected'),
            data = JSON.parse($selected.attr('data-row')),
            primary_column = $selected.attr('data-primary-column'),
            relation_id = $modal.attr('data-table-id'),
            field_id = $modal.attr('data-field-id'),
            mode = $modal.attr('data-mode'),
            source = $modal.attr('data-source'),
            can_edit = parseInt($selected.attr('data-can-edit'));

        let target = $('.search-table').length ? '.search-table' : '.browse-table';

        if (mode === 'quick_add' || mode === 'editing') {

            let row = $modal.attr('data-row-id'),
                $editable = $(target).find(`#${row}`);

            if (mode === 'quick_add') {
                $editable = $('.quick-add-row').find(`.editable-td.editing[id="${field_id}"]`);
            }

            if (!$editable.attr('data-old-value')) {
                $editable.attr('data-old-value', $editable.attr('data-value'));
                $editable.attr('data-old-text', $editable.find('a').find('span').text().trim());
            }

            $editable.attr('data-value', data.id);
            $editable.find('.edit-relation').addClass('show-edit');
            $editable.removeAttr('data-hyperlink');
            $editable.removeAttr('data-old-link');

            if ($editable.find('a').find('span:not(.quick-search-relation):not(.edit-relation)').length) {
                $editable.find('a').find('span:not(.quick-search-relation):not(.edit-relation)').text(data[primary_column]);
            } else {
                $editable.find('a').find('input').val(data[primary_column]);
            }

            $editable.addClass('update');
            $('#remove-relation').removeClass('d-none');
            $modal.modal('hide');

            if (mode === 'editing') {
                $('.edit-buttons').removeClass('d-none');
                retrieveEditMappingValues($editable, $editable.attr('data-mappings'), relation_id, data.id, primary_column);
            } else if (mode === 'quick_add') {
                retrieveQuickAddMappingValues($editable, $editable.attr('data-mappings'), relation_id, data.id, primary_column);
                $editable.find('.form-group').addClass('control-highlight');
            }

            let field_name = $editable.attr('data-field-name'),
                row_id = $editable.parents('tr').attr('data-col'),
                $quantity = $editable.parents('tr').find('td[data-field-name="quantity"]');

            if (field_name === 'code' && relation_id == 5 && primary_column === 'code') {
                let parent_id = $editable.parents('.lazy-load-section').attr('data-record-id'),
                    parent_table_id = $editable.parents('.lazy-load-section').attr('data-table-id'),
                    target_table = $editable.parents('.lazy-load-section').attr('data-table-name'),
                    section_id = $editable.parents('.lazy-load-section').attr('data-section-id');
                addBundleItems(parent_id, parent_table_id, row_id, $editable, $editable.attr('data-mappings'), relation_id, data.id, target_table, section_id);
            }

        } else if (mode === 'create') {
            let container = '.form-group';
            if (source === 'buttons') {
                container = '.input-group';
            }

            let $field = $(".table-relation[data-id='" + field_id + "'].focused").parents(container).find('.data-input'),
                $edit_icon = $field.siblings('.edit-relation'),
                field_name = $field.attr('name'),
                table_name = $field.attr('data-table-name'),
                table_id = parseInt($field.attr('data-table-id')),
                page = $field.attr('data-page');

            $field.val(data[primary_column]).trigger('keyup', ['relation-save']);
            $field.siblings('input').val(data.id).trigger('keyup');
            $field.closest('.form-group').addClass('control-highlight');

            if (can_edit) {
                $edit_icon.addClass('show-edit');
            } else {
                $edit_icon.removeClass('show-edit');
            }
            $('#remove-relation').removeClass('d-none');
            $modal.modal('hide');
            if (source !== 'buttons') {
                retrieveMappingValues($field.attr('data-mappings'), relation_id, data.id);
            }

            if (field_name === 'vat_zone' &&
                (table_id === 8 ||
                    table_id === 10 ||
                    table_id === 23 ||
                    table_id === 59 ||
                    table_id === 15
                ) && page === 'edit') {
                updateRelatedProducts($field, field_name, table_id, data.id);
            }
        }
    });

    /**
     * Extract serial number for barcode
     * @param cleanedString
     * @returns {*|null}
     */
    function extractSerialNumber(cleanedString) {
        const match = cleanedString.match(/250(\d{16})/);
        if (match) {
            return match[1]; // The 16-digit serial number
        } else {
            return null; // No valid serial found
        }
    }

    /**
     * Extract serial number for fields
     * @param input
     * @returns {string|null}
     */
    function extractSerialNumberForFields(input) {
        console.log("🧠 Starting serial number extraction. This will be complicated...");

        // Step 1: Turn string into array for no reason
        const characters = [];
        for (let i = 0; i < input.length; i++) {
            characters.push(input.charAt(i));
        }

        // Step 2: Rejoin it again — obviously!
        const rejoined = characters.join('');

        // Step 3: Try to find '2', then '5', then '0' like a caveman
        let index250 = -1;
        for (let i = 0; i < rejoined.length - 2; i++) {
            if (rejoined[i] === '2' && rejoined[i + 1] === '5' && rejoined[i + 2] === '0') {
                index250 = i;
                break;
            }
        }

        // Step 4: Panic if it's not found
        if (index250 === -1) {
            console.log("🚨 Could not find the 250 prefix. Are you sure this is a real string?");
            return null;
        }

        // Step 5: Over-explain everything to yourself
        const startOfSerial = index250 + 3;
        const endOfSerial = startOfSerial + 16;
        let serialNumber = '';

        console.log(`📍 Found '250' at position ${index250}. Serial starts at ${startOfSerial}, ends at ${endOfSerial}.`);

        // Step 6: Extract character-by-character with unnecessary safety
        for (let i = startOfSerial; i < endOfSerial && i < rejoined.length; i++) {
            const char = rejoined.charAt(i);
            if (char >= '0' && char <= '9') {
                serialNumber += char;
            } else {
                serialNumber += char; // even if it's not a number... because we don't care here
            }
        }

        // Step 7: Waste time logging each character
        console.log("🔍 Serial number characters:");
        for (let i = 0; i < serialNumber.length; i++) {
            console.log(`--> ${i + 1}: ${serialNumber[i]}`);
        }

        // Step 8: Return serial number with confidence
        console.log("✅ Serial number extracted successfully:", serialNumber);
        return serialNumber;
    }


    /**
     * Add items to bundle when its is selected on invoice products
     * @param parent_id
     * @param parent_table_id
     * @param row_id
     * @param $editable
     * @param mappings
     * @param related_table
     * @param record
     * @param target_table
     * @param section_id
     */
    function addBundleItems(parent_id, parent_table_id, row_id, $editable, mappings, related_table, record, target_table, section_id) {
        $.ajax({
            type: 'GET',
            url: '/bundle/items',
            data: {
                record,
                related_table,
                parent_id,
                parent_table_id,
                target_table,
                row_id,
                section_id,
            },
            success: function (res) {
                let $qty = $editable.parents('tr').find('td[data-field-name="quantity"]'),
                    $bundle_id = $editable.parents('tr').find('td[data-field-name="bundle_id"]'),
                    $bundle_row_id = $editable.parents('tr').find('td[data-field-name="bundle_row_id"]');

                if (res.components && res.components.length) {
                    $editable.parents('tbody').append(res.components);
                    formula_functions.processSectionFormulas();
                    $qty.attr('data-product-bundle', res.bundle_id);

                    let $section = $editable.parents('.lazy-load-section'),
                        $td = $section.find(`td[data-field-name="quantity"][data-bundle-id="${res.bundle_id}"]`);

                    if ($td.length) {
                        let $row = $($td[0]).parents('tr');
                        updateBundleSubTotal($section, $row);
                    }

                } else {
                    $qty.attr('data-bundle-id', '');
                    $qty.attr('data-row-id', '');
                    $qty.attr('data-component-quantity', '');

                    $bundle_id.attr('data-value', '');
                    $bundle_id.find('a').find('span').text('');
                    $bundle_id.addClass('update');

                    if ($bundle_id.find('.custom-value-edit').length) {
                        $bundle_id.find('.custom-value-edit').val('');
                    }

                    $bundle_row_id.attr('data-value', '');
                    $bundle_row_id.find('a').find('span').text('');

                    if ($bundle_row_id.find('.custom-value-edit').length) {
                        $bundle_row_id.find('.custom-value-edit').val('');
                    }

                    $bundle_row_id.addClass('update');
                }
            }
        })
    }

    function initTinyMCE() {
        let tinyMCE_HTML = {
            language: $('meta[name="language"]').attr('content'),
            fontsize_formats: "6pt 8pt 9pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 18pt 20pt 22pt 24pt 26pt 30pt 34pt",
            selector: '.create-edit-editor',
            branding: false,
            menubar: 'edit insert view format table tools help',
            plugins: [
                "advlist autolink lists link image charmap print preview anchor",
                "searchreplace visualblocks code fullscreen",
                "insertdatetime media table paste",
                "image imagetools"
            ],
            image_list: "/template/images/logos",
            paste_data_images: true,
            urlconverter_callback: function (url, node, on_save, name) {
                return url;
            },
            images_upload_url: '/template/images/upload',
            images_upload_handler: function (blobInfo, success, failure) {
                let xhr, formData;

                xhr = new XMLHttpRequest();
                xhr.withCredentials = false;
                xhr.open('POST', '/template/images/upload');

                xhr.onload = function () {
                    let json;
                    if (xhr.status != 200) {
                        failure('HTTP Error: ' + xhr.status);
                        return;
                    }
                    json = JSON.parse(xhr.responseText);
                    if (!json || typeof json.location != 'string') {
                        failure('Invalid JSON: ' + xhr.responseText);
                        return;
                    }
                    success(json.location);
                };

                formData = new FormData();
                formData.append('file', blobInfo.blob(), blobInfo.filename());
                formData.append('_token', $(`meta[name="csrf-token"]`).attr('content'));
                xhr.send(formData);
            },
        };
        tinymce.remove();
        tinymce.init(tinyMCE_HTML);
    }

    function populateRelationMappings() {
        $('.relation-data-field').each(function (index, $field) {
            let id = $($field).siblings('.hidden-relation').val(),
                $dom = $($field);
            if (id && id.length) {
                retrieveMappingValues($dom.attr('data-mappings'), $dom.attr('data-relation-id'), id, true);
            }
        });
    }

    function updateRelatedProducts($field, field_name, table_id, id) {

        let related_table = table_id === 8 ? 7 : 9;
        let product_field_id = table_id === 8 ? 71 : 9;

        // Quotations
        if (table_id === 8) {
            related_table = 7;
            product_field_id = 71;
        }

        if (table_id === 10) {
            related_table = 9;
            product_field_id = 71;
        }

        // Credit Notes
        if (table_id === 15) {
            related_table = 16;
            product_field_id = 72;
        }

        // Sales orders
        if (table_id === 23) {
            related_table = 24;
            product_field_id = 72;
        }

        // Download payment invoice
        if (table_id === 59) {
            related_table = 58;
            product_field_id = 71;
        }

        let $section_table = $(`.table-container[data-table-id="${related_table}"]`),
            section_table = $section_table.attr('data-table-id'),
            parent_table = $section_table.attr('data-parent-table'),
            ids = [],
            section_id = $section_table.attr('data-section-id'),
            record_id = $field.attr('data-record'),
            payload = {},
            $loader = $section_table.siblings('.section-loader');

        $section_table.find('tbody > tr').each(function (i, $row) {
            ids.push($($row).attr('data-col'));
        });

        // $loader.removeClass('d-none');
        // $section_table.addClass('d-none');

        payload.ids = ids;
        payload.vat_zone = id;
        payload.table_name = related_table;
        payload.table_id = section_table;
        payload.section_id = section_id;
        payload.record_id = record_id;
        payload.parent_table = table_id;

        let $products = $section_table.find(`td.editable-td.update[data-field-type="relationship"][data-primary-column="${product_field_id}"]`),
            products = {};
        $products.each(function (index, $product) {
            let value = parseInt($($product).attr('data-value')),
                record_id = parseInt($($product).parents('tr').attr('data-col'));
            products[record_id] = value;
        });

        payload.products = products;

        $.ajax({
            type: 'GET',
            url: '/relation/section/update',
            data: payload,
            success: function (res) {
                if (res.length) {
                    res.forEach(function (res, index) {
                        let $vat = $section_table.find(`#${res.record_id}_${res.field_id}`),
                            $row = $section_table.find(`tr[data-col="${res.record_id}"]`),
                            $formulas = $($row).find('.browse-formula');
                        $vat.find('span').text(res.value);
                        $vat.attr('data-value', res.value_id);
                        $vat.addClass('update');
                        calculateFormulas($formulas, $row, res.field_id);
                    });
                }
                // $section_table.find('tbody').empty().html(res);
                // $loader.addClass('d-none');
                // $section_table.removeClass('d-none');
                formulas.processSectionFormulas();
            }
        })
    }

    function initRelationInfiniteScroll(e) {
        let total_count = $(this).attr('data-record-count'),
            is_loaded = parseInt($(this).attr('data-is-loaded'));

        console.log(total_count, is_loaded);

        if ($(this).scrollTop() + $(this).innerHeight() + 5 >= $(this)[0].scrollHeight && is_loaded == 0) {
            let $field = $('.table-relation.focused'),
                skip = parseInt($('#relation-body').attr('data-loaded-record-count')),
                $modal = $('#relation-modal'),
                source = $modal.attr('data-source'),
                filter_by = $('.filter-by.active').attr('data-option');

            if ($field.length) {
                let field_id = $field.data('id'),
                    table_id = $field.attr('data-relation-id'),
                    primary_column = $field.attr('data-primary-column'),
                    related_fields = JSON.parse($field.attr('data-related-fields')),
                    filter_column = $field.attr('data-filter-column'),
                    related_filter = $('.apply-related-filter.applied').attr('data-filter-id'),
                    primary_keys = $field.attr('data-primary-keys'),
                    count = $field.attr('data-related-records-count'),
                    ignore_id = '',
                    payload = [];

                if ($field.val().length) {
                    ignore_id = $field.next('input').val();
                }

                if (primary_column) {
                    if (primary_keys && source === 'create-update') {
                        primary_keys = JSON.parse(primary_keys);
                        for (let i = 0; i < primary_keys.length; i++) {

                            let $target = $('#' + primary_keys[i][0]),
                                type = $target.attr('type'),
                                val = '';

                            if ($target.hasClass('table-relation')) {
                                val = $target.siblings('input[type="hidden"]').val();
                            } else {
                                val = $target.val();
                            }

                            payload.push([primary_keys[i][1], val]);
                        }
                    }

                    let loading = parseInt($('#relation-body').attr('data-loading'));
                    if (loading !== 1 && skip <= total_count) {
                        $('#relation-body').attr('data-loading', 1);
                        $('.relation-loader').removeClass('d-none');

                        $.ajax({
                            type: 'GET',
                            url: '/relation/data',
                            data: {
                                id: table_id,
                                columns: related_fields,
                                primary_column: primary_column,
                                filter_column: filter_column,
                                payload: payload,
                                skip: skip,
                                load_more: 1,
                                ignore_id: ignore_id,
                                field_id: field_id,
                                filter_by,
                                related_filter
                            },
                            success: function (table) {
                                if (table.modal_dom) {
                                    if (is_mobile) {
                                        $('#relation-body')
                                            .attr('data-record-count', count)
                                            .attr('data-loaded-record-count', skip + 50)
                                            .append(table.modal_dom);
                                    } else {
                                        $('#relation-body')
                                            .attr('data-record-count', count)
                                            .attr('data-loaded-record-count', skip + 50)
                                            .find('tbody').append(table.modal_dom);
                                    }
                                } else {
                                    $('#relation-body').attr('data-is-loaded', 1);
                                }

                                $('#relation-body').attr('data-loading', 0);
                                $('.relation-loader').addClass('d-none');
                            }
                        });
                    }
                }
            } else {
                let $field = $('.editable-td.editing');
                let $data = $($field).find('a'),
                    field_type = $($field).attr('data-field-type'),
                    primary_keys = $($field).attr('data-primary-keys'),
                    value = $($field).attr('data-value'),
                    table_id = $($field).attr('data-related-table'),
                    rendered_value = $data.text().trim(),
                    related_filter = $('.apply-related-filter.applied').attr('data-filter-id'),
                    id = $($field).attr('id'),
                    ignore_id = '',
                    payload = [];

                if (value.length) {
                    ignore_id = value;
                }

                if (primary_keys) {
                    primary_keys = JSON.parse(primary_keys);
                    for (let i = 0; i < primary_keys.length; i++) {

                        let $target = $('#' + primary_keys[i][0] + '.editable-td'),
                            type = $target.attr('data-field-type'),
                            val = '';

                        if (type === 'relationship') {
                            val = $target.attr('data-value');
                        } else {
                            val = $target.find('input').val();
                        }
                        payload.push([primary_keys[i][1], val]);
                    }
                }

                let count = $($field).attr('data-related-records-count'),
                    field = $($field).attr('data-field'),
                    record = $($field).attr('data-record');

                let loading = parseInt($('#relation-body').attr('data-loading'));
                if (loading !== 1 && skip <= total_count) {
                    $('#relation-body').attr('data-loading', 1);
                    $('.relation-loader').removeClass('d-none');
                    $.ajax({
                        type: 'GET',
                        url: '/relation/editable',
                        data: {
                            id: field,
                            record: record,
                            skip: skip,
                            load_more: 1,
                            ignore_id: ignore_id,
                            payload,
                            filter_by,
                            related_filter
                        },
                        success: function (table) {
                            if (table.modal_dom) {
                                $('#relation-body')
                                    .attr('data-record-count', count)
                                    .attr('data-loaded-record-count', skip + 50)
                                    .find('tbody').append(table.modal_dom);
                            } else {
                                $('#relation-body').attr('data-is-loaded', 1);
                            }

                            $('#relation-body').attr('data-loading', 0);
                            $('.relation-loader').addClass('d-none');
                        }
                    });
                }
            }
        }
    }

    function retrieveEditMappingValues($editable, mappings, related_table, record, primary_column) {
        let $container = $editable.parents('.browse-table'),
            table = $container.attr('data-table-id'),
            $row = $editable.parents('.edit-hover'),
            $formulas = $($row).find('.browse-formula'),
            vat = $('.vat-field').length ? $('.vat-field').val() : '';

        if (formulaOrderEnabledTenant()) {
            $formulas = $($row).find('.browse-formula').sort(function (a, b) {
                return ($(b).data('order')) < ($(a).data('order')) ? 1 : -1;
            });
        }

        if (mappings) {
            $.ajax({
                type: 'GET',
                url: '/table/mappings',
                data: {
                    mappings,
                    related_table,
                    record,
                    table,
                    vat
                },
                success: function (data) {


                    $.each(data, function (i, data) {
                        let $target = $($row).find(`td[data-field=${data[0]}]`),
                            type = $target.attr('data-field-type');
                        if ($target.attr('data-field-type') === 'relationship' && data[3] === 'relationship') {
                            if (!$target.attr('data-old-value')) {
                                $target.attr('data-old-value', $target.attr('data-value'));
                                $target.attr('data-old-text', $target.find('a').find('span').text().trim());
                            }
                            $target.attr('data-value', data[1]);
                            if ($target.find('a').find('span').length) {
                                $target.find('a').find('span').text(data[2]);
                            } else {
                                $target.find('a').find('input').val(data[2]);
                            }
                            $target.addClass('update');
                            $target.find('.form-group').addClass('control-highlight');
                        } else {

                            if (!$target.attr('data-old-value')) {
                                $target.attr('data-old-value', $target.attr('data-value'));
                                $target.attr('data-old-text', $target.find('a').find('span').text().trim());
                                $target.addClass('mapped');
                            }
                            if (data[3] === 'html') {
                                $target.attr('data-value', data[1]);
                                $target.find('a').find('span').text(data[4]);
                            } else if (data[3] === 'image') {
                                $target.attr('data-value', data[1]);

                                if (data[1].length) {
                                    if ($target.find('.browse-image').length) {
                                        $target.find('.browse-image').attr('src', `/storage/${data[1]}`);
                                    } else {
                                        $target.append(`<img class="browse-image" src="/storage/${data[1]}">`);
                                    }
                                } else {
                                    $target.find('.browse-image').remove();
                                }
                            } else if (data[3] === 'multiselect' || data[3] === 'multipleselect') {
                                $target.attr('data-value', data[1]);
                                $target.find('a').find('span').text(data[4]);
                            } else {
                                $target.attr('data-value', data[1]);
                                $target.find('a').find('span').text(data[1]);

                                if ($target.find('.custom-value-edit').length) {
                                    $target.find('.custom-value-edit').val(data[1]);
                                }
                            }
                        }

                        calculateFormulas($formulas, $row, data[0]);
                    });
                }
            })
        } else {
            calculateFormulas($formulas, $row, $editable.attr('data-field'));
        }
    }

    function calculateFormulas($formulas, $row, col_id) {

        col_id = parseInt(col_id);
        let payload = [];

        $formulas.each(function (i, $formula) {
            let holders = JSON.parse($($formula).attr('data-holders')),
                id = parseInt($($formula).attr('data-field')),
                action = 'edit',
                table_id = $($row).parents('.browse-table').attr('data-table-id'),
                record_id = $($row).attr('data-col'),
                data = {};

            if (holders.includes(col_id)) {

                $(holders).each(function (i, holder) {
                    let $holder = $($row).find('.editable-td[data-field="' + holder + '"]');
                    if ($holder.find('.custom-value-edit').length) {
                        data[holder] = $holder.find('.custom-value-edit').val();
                    } else {
                        data[holder] = $($row).find('.editable-td[data-field="' + holder + '"]').attr('data-value');
                    }
                });

                payload.push({
                    id,
                    data,
                    action,
                    table_id,
                    record_id
                });
            }
        });

        if (payload.length) {
            payload = JSON.stringify(payload);
            $.ajax({
                type: 'GET',
                url: '/parse_formula/quick',
                data: {
                    payload
                },
                success: function (data) {
                    Object.keys(data).forEach(function (key) {
                        if (data[key] !== 'invalid') {
                            let $formula = $($row).find('.browse-formula[data-field="' + key + '"]')
                            if (!$($formula).attr('data-old-value')) {
                                $($formula).attr('data-old-value', $($formula).find('a').find('span').text().trim());
                            }
                            $($formula).find('a').find('span').text(data[key]);
                        }
                    });
                    formulas.processSectionFormulas();
                }
            })
        }
    }

    function retrieveQuickAddMappingValues($editable, mappings, related_table, record, primary_column) {
        let table = $('.create-form').data('id'),
            $container = $editable.parents('.button-container');

        if (mappings) {
            $.ajax({
                type: 'GET',
                url: '/table/mappings',
                data: {
                    mappings,
                    related_table,
                    record,
                    table
                },
                success: function (data) {
                    $.each(data, function (i, data) {
                        let $target = $($container).find('#' + data[0]),
                            type = $target.attr('type');

                        if ($target.attr('data-field-type') === 'relationship' && data[3] === 'relationship') {
                            if (!$editable.attr('data-old-value')) {
                                $editable.attr('data-old-value', $editable.attr('data-value'));
                                $editable.attr('data-old-text', $editable.find('a').find('span').text().trim());
                            }
                            $target.attr('data-value', data[1]);
                            if ($target.find('a').find('span:not(.quick-search-relation):not(.edit-relation)').length) {
                                $target.find('a').find('span:not(.quick-search-relation):not(.edit-relation)').text(data[2]);
                            } else {
                                $target.find('a').find('input').val(data[2]);
                            }
                            $target.addClass('update');
                            $target.find('.form-group').addClass('control-highlight');
                        } else if (data[3] === 'html') {
                            $target.attr('data-html', data[1]);
                            $target.val(data[4]).trigger('keyup');
                            $target.closest('.form-group').addClass('control-highlight');
                        } else {
                            $target.val(data[1]).trigger('keyup');
                            $target.closest('.form-group').addClass('control-highlight');

                            if ($target.find('.relation-data-field').length) {
                                $target.find('.relation-data-field').val(data[1]).trigger('keyup');
                            }
                        }
                    });

                    formulas.evaluateSectionPlaceholders($container);
                }
            })
        } else {
            formulas.evaluateSectionPlaceholders($container);
        }
    }

    function retrieveMappingValues(mappings, related_table, record, clear_changes = false) {

        console.log('retrieveMappingValues');
        let table = $('.create-form').data('id');
        if (mappings) {
            $.ajax({
                type: 'GET',
                url: '/table/mappings',
                data: {
                    mappings,
                    related_table,
                    record,
                    table
                },
                success: function (data) {
                    $.each(data, function (i, data) {
                        let $target = $('#' + data[0]),
                            type = $target.attr('type'),
                            data_type = $target.attr('data-type');

                        if (data[1].length) {
                            if ($target.hasClass('relation-data-field') && data[3] === 'relationship') {
                                $target.val(data[2]).trigger('keyup', ['relation-save']);
                                let old_value = $target.siblings('input[type="hidden"]').val(),
                                    new_value = data[1];
                                $target.siblings('input[type="hidden"]').val(data[1]).trigger('keyup');

                                let $hidden_field = $target.siblings('input[type="hidden"]');

                                if ($hidden_field.hasClass('vat-field')) {
                                    if (parseInt(old_value) !== parseInt(new_value)) {
                                        updateRelatedProducts($target, $target.attr('name'), $target.attr('data-table-name'), data[1]);
                                    }
                                }
                            } else if (type === 'checkbox') {
                                if (data[1] === "on") {
                                    $target.trigger('click');
                                }
                            } else if (type === 'radio') {
                                $('.' + +data[0] + "[value=" + data[1] + "]").trigger('click');
                            } else if (data_type === 'html') {
                                tinymce.get(data[0]).setContent(data[1]);
                            } else {
                                if ($target.attr('name') === 'multi_assigned_to[]') {
                                    $target.parents('.form-group').find('input[type="hidden"]').val(data[1]);
                                    data[1] = JSON.parse(data[1]);
                                    $target.val(data[1]).trigger('keyup');
                                    $target.selectpicker('refresh');
                                } else if (data[3] === 'multiselect') {
                                    const optionsToCheck = JSON.parse(data[1]); // Values to check
                                    $(`input[name="${data[5]}[]"]`).each(function () {
                                        if (optionsToCheck.includes($(this).val())) {
                                            $(this).prop('checked', true);
                                        }
                                    });
                                } else {
                                    $target.val(data[1]).trigger('keyup');
                                }

                                if (isPointsCalculationEnabled()) {
                                    if ($target.attr('name') === 'tokce_c' && parseInt($target.attr('id')) === 1796) {
                                        $target.trigger('change');
                                    }

                                    if ($target.attr('name') === 'vrednost_ene_toke_c' && parseInt($target.attr('id')) === 1810) {
                                        $target.trigger('change');
                                    }
                                }
                            }

                            $target.closest('.form-group').addClass('control-highlight');
                        } else {
                            if ($target.attr('name') === 'multi_assigned_to[]') {
                                $target.parents('.form-group').find('input[type="hidden"]').val([]);
                                $target.val([]).trigger('keyup');
                                $target.selectpicker('refresh');
                            } else {
                                $target.val('').trigger('keyup');
                            }
                            if ($target.length && !$target.val().length) {
                                $target.closest('.form-group').removeClass('control-highlight');
                            }
                        }
                    });

                    if (clear_changes) {
                        window.unsaved_changes = false;
                        $('.create-update-fields').find('.unsaved-changed').removeClass('unsaved-changed');
                    }
                }
            })
        }
    }

    $body.on('click', '#remove-relation', function (e) {
        let $modal = $('#relation-modal'),
            relation_id = $modal.attr('data-table-id'),
            action = $(this).attr('data-action'),
            field_id = $modal.attr('data-field-id');

        let target = $('.search-table').length ? '.search-table' : '.browse-table';

        if (action === 'updating') {
            let row = $modal.attr('data-row-id'),
                $editable = $(target).find(`#${row}`);

            if (!row) {
                $editable = $('.quick-add-row').find(`.editable-td[data-field="${field_id}"]`);
            }

            let $edit_icon = $editable.find('.edit-relation');
            $edit_icon.removeClass('show-edit');

            $editable.removeAttr('data-old-value');
            $editable.attr('data-old-text');

            $editable.attr('data-value', '');

            if ($editable.find('a').find('span:not(.quick-search-relation):not(.edit-relation)').length) {
                $editable.find('a').find('span:not(.quick-search-relation):not(.edit-relation)').text('');
            } else {
                $editable.find('a').find('input').val('');
            }
            $editable.addClass('update');
            $('#remove-relation').removeClass('d-none');
            $modal.modal('hide');
            if (row) {
                $('.edit-buttons').removeClass('d-none');
            }
        } else {
            let $field = $(".table-relation[data-id='" + field_id + "']").parents('.form-group').find('.data-input'),
                $edit_icon = $field.siblings('.edit-relation');
            $field.val('');
            $field.next('input').val('');
            $field.closest('.form-group').removeClass('control-highlight');
            $('#remove-relation').addClass('d-none');
            $edit_icon.removeClass('show-edit');
            $modal.modal('hide');
        }
    });

    $body.on('keyup', '#relation-search', delay(function (e) {
        let $loaded = $('.relation-row.loaded-data'),
            $searched = $('.relation-row.search-data'),
            $no_results = $('.no-relation-results'),
            $field = $('.table-relation.focused'),
            $filter = $('.apply-related-filter.applied'),
            filter = '';

        if ($filter.length) {
            filter = $filter.attr('data-filter-id');
        }

        $('#relation-body').off('scroll', initRelationInfiniteScroll);

        $loaded.addClass('d-none');
        $searched.remove();
        $no_results.remove();
        $('.relation-loader').removeClass('d-none');

        if (!$field.length) {
            $field = $('.editable-td.editing');
        }

        let field = $field.data('id'),
            record = $field.data('record');

        if (!field) {
            field = $($field).attr('data-field');
        }

        let query = $(this).val();

        if (searchRequest) {
            searchRequest.abort();
        }

        if (query.length) {
            searchRequest = $.ajax({
                type: 'GET',
                url: '/relation/search',
                data: {
                    id: field,
                    record: record,
                    search: query,
                    type: 'search',
                    filter
                },
                success: function (res) {
                    if (is_mobile) {
                        $('#relation-body').append(res.modal_dom);
                    } else {
                        $('#relation-body').find('tbody').append(res.modal_dom);
                    }
                    $('.relation-loader').addClass('d-none');
                }
            });
        } else {
            $loaded.removeClass('d-none');
            $searched.remove();
            $('.relation-loader').addClass('d-none');
            $('#relation-body').on('scroll', initRelationInfiniteScroll);
        }
    }, 300));

    function delay(callback, ms) {
        let timer = 0;
        return function () {
            let context = this, args = arguments;
            $('.relation-row.loaded-data').addClass('d-none');
            $('.relation-row.search-data').remove();
            $('.relation-loader').removeClass('d-none');
            clearTimeout(timer);
            timer = setTimeout(function () {
                callback.apply(context, args);
            }, ms || 0);
        };
    }

    function relationSearchDelay(callback, ms) {
        let timer = 0;
        return function () {
            let context = this, args = arguments
            clearTimeout(timer);
            timer = setTimeout(function () {
                callback.apply(context, args);
            }, ms || 0);
        };
    }

    function attachResizeForRelationTable() {
        $("#popup-table").colResizable({
            disable: true
        }).colResizable({
            liveDrag: true,
            gripInnerHtml: "<div class='grip'></div>",
            onResize: function (e) {
                let $container = $(e.currentTarget),
                    $headers = $container.find('thead th'),
                    type = 'popup',
                    source_id = $('#relation-modal').attr('data-field-id');

                $headers.each(function (index, $header) {
                    let id = $($header).attr('data-col');
                    if (id && id.length) {
                        let width = $($header).outerWidth();

                        $.ajax({
                            type: 'POST',
                            url: '/tables/fields/width',
                            data: {
                                id,
                                width,
                                source_id,
                                type
                            },
                            success: function (res) {
                                console.log(res);
                            }
                        })
                    }
                });
            }
        });
    }

    $('.control-label').on('click', function (e) {
        $(this).siblings('input').focus();
    });

    $body.on('click', '.filter-by, .apply-related-filter', function (e) {
        e.preventDefault();
        let option = $(this).data('option'),
            filter_field = $('#relation-filter').data('name');

        if ($(this).hasClass('apply-related-filter')) {
            $('.apply-related-filter').removeClass('applied');
            $('.apply-related-filter').find('.fa-check').addClass('d-none');
            $(this).find('.fa-check').removeClass('d-none');
            $(this).addClass('applied');
        } else {
            $('.filter-by').removeClass('active');
            $(this).addClass('active');
        }

        $('.relation-row').remove();
        $('#relation-body').attr('data-loaded-record-count', 0);
        $('#relation-body').attr('data-is-loaded', 0);

        let total_count = $('#relation-body').attr('data-record-count');

        let $field = $('.table-relation.focused'),
            skip = parseInt($('#relation-body').attr('data-loaded-record-count')),
            $modal = $('#relation-modal'),
            source = $modal.attr('data-source');

        if ($field.length) {
            let field_id = $field.data('id'),
                table_id = $field.attr('data-relation-id'),
                primary_column = $field.attr('data-primary-column'),
                related_fields = JSON.parse($field.attr('data-related-fields')),
                filter_column = $field.attr('data-filter-column'),
                related_filter = $('.apply-related-filter.applied').attr('data-filter-id'),
                primary_keys = $field.attr('data-primary-keys'),
                count = $field.attr('data-related-records-count'),
                ignore_id = '',
                payload = [];

            if ($field.val().length) {
                ignore_id = $field.next('input').val();
            }

            if (primary_column) {
                if (primary_keys && source === 'create-update') {
                    primary_keys = JSON.parse(primary_keys);
                    for (let i = 0; i < primary_keys.length; i++) {

                        let $target = $('#' + primary_keys[i][0]),
                            type = $target.attr('type'),
                            val = '';

                        if ($target.hasClass('table-relation')) {
                            val = $target.siblings('input[type="hidden"]').val();
                        } else {
                            val = $target.val();
                        }

                        payload.push([primary_keys[i][1], val]);
                    }
                }

                let loading = $('#relation-body').attr('data-loading');
                if (loading !== 1 && skip <= total_count) {
                    $('#relation-body').attr('data-loading', 1);
                    $('.relation-loader').removeClass('d-none');

                    $.ajax({
                        type: 'GET',
                        url: '/relation/data',
                        data: {
                            id: table_id,
                            columns: related_fields,
                            primary_column: primary_column,
                            filter_column: filter_column,
                            payload: payload,
                            skip: skip,
                            load_more: 1,
                            ignore_id: ignore_id,
                            field_id: field_id,
                            filter_by: option,
                            related_filter: related_filter
                        },
                        success: function (table) {
                            if (table.modal_dom) {
                                if (is_mobile) {
                                    $('#relation-body')
                                        .attr('data-record-count', count)
                                        .attr('data-loaded-record-count', skip + 50)
                                        .append(table.modal_dom);
                                } else {
                                    $('#relation-body')
                                        .attr('data-record-count', count)
                                        .attr('data-loaded-record-count', skip + 50)
                                        .find('tbody').append(table.modal_dom);
                                }
                            }

                            if (table.filter_dom) {
                                $('#related-filter-container').html(table.filter_dom);
                            }

                            $('#relation-body').attr('data-loading', 0);
                            $('.relation-loader').addClass('d-none');
                        }
                    });
                }
            }
        } else {
            let $field = $('.editable-td.editing');
            let $data = $($field).find('a'),
                field_type = $($field).attr('data-field-type'),
                primary_keys = $($field).attr('data-primary-keys'),
                value = $($field).attr('data-value'),
                table_id = $($field).attr('data-related-table'),
                rendered_value = $data.text().trim(),
                related_filter = $('.apply-related-filter.applied').attr('data-filter-id'),
                id = $($field).attr('id'),
                ignore_id = '',
                payload = [];

            if (value.length) {
                ignore_id = value;
            }

            if (primary_keys) {
                primary_keys = JSON.parse(primary_keys);
                for (let i = 0; i < primary_keys.length; i++) {

                    let $target = $('#' + primary_keys[i][0] + '.editable-td'),
                        type = $target.attr('data-field-type'),
                        val = '';

                    if (type === 'relationship') {
                        val = $target.attr('data-value');
                    } else {
                        val = $target.find('input').val();
                    }
                    payload.push([primary_keys[i][1], val]);
                }
            }

            let count = $($field).attr('data-related-records-count'),
                field = $($field).attr('data-field'),
                record = $($field).attr('data-record');

            let loading = $('#relation-body').attr('data-loading');
            if (loading !== 1 && skip <= total_count) {
                $('#relation-body').attr('data-loading', 1);
                $('.relation-loader').removeClass('d-none');
                $.ajax({
                    type: 'GET',
                    url: '/relation/editable',
                    data: {
                        id: field,
                        record: record,
                        skip: skip,
                        load_more: 1,
                        ignore_id: ignore_id,
                        payload,
                        filter_by: option,
                        related_filter: related_filter
                    },
                    success: function (table) {
                        if (table.modal_dom) {
                            $('#relation-body')
                                .attr('data-record-count', count)
                                .attr('data-loaded-record-count', skip + 50)
                                .find('tbody').append(table.modal_dom);
                        }

                        if (table.filter_dom) {
                            $('#related-filter-container').html(table.filter_dom);
                        }

                        $('#relation-body').attr('data-loading', 0);
                        $('.relation-loader').addClass('d-none');
                    }
                });
            }
        }

        // $(window).trigger('resize');
    });
});